import { render } from "./BenefitsHome.vue?vue&type=template&id=1614131a&scoped=true"
import script from "./BenefitsHome.vue?vue&type=script&lang=js"
export * from "./BenefitsHome.vue?vue&type=script&lang=js"

import "./BenefitsHome.vue?vue&type=style&index=0&id=1614131a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1614131a"]])

export default __exports__